"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeFlexFlowShorthand = exports.openFlexFlowShorthand = void 0;
var tslib_1 = require("tslib");
var css_data_types_1 = require("../../css-data-types");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
// flex-flow
var openFlexFlowShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: 'flex-flow',
        parts: [
            { prop: 'flex-direction', dataType: css_data_types_1.flexDirectionDataType },
            { prop: 'flex-wrap', dataType: css_data_types_1.flexWrapDataType },
        ],
        shorthandOpener: function (astNodes, api, parts) { return (0, shorthand_parser_utils_1.unorderedListShorthandOpener)(parts)(astNodes, api); },
    });
};
exports.openFlexFlowShorthand = openFlexFlowShorthand;
var closeFlexFlowShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.shorthandCloserTemplate)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["", " ", ""], ["", " ", ""])), 'flex-direction', 'flex-wrap'));
};
exports.closeFlexFlowShorthand = closeFlexFlowShorthand;
var templateObject_1;
//# sourceMappingURL=flex-flow-shorthand.js.map